/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_SubtitleInputs */

const vi_tea_purchase_subtitle = /** @type {(inputs: Tea_Purchase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý đơn mua chè từ hộ trồng, ghi nhận thanh toán và sản xuất.`)
};

/**

* @param {Tea_Purchase_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_subtitle = /** @type {((inputs?: Tea_Purchase_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_subtitle(inputs)
});